<template>
	<ul class="list-unstyled">
		<li
			class="list-option media"
			v-for="option in options"
			:key="option.key"
			:class="{ 'selected': value.includes(option.key) }"
			@click="onClick(option.key)">
			<!-- <img src="" class="media-img mr-3" :alt="courier.label"> -->
			<div class="custom-control custom-checkbox">
				<input type="checkbox" class="custom-control-input" :checked="value.includes(option.key)">
				<label class="custom-control-label"></label>
			</div>
			<div
				class="media-img shipping-logo mr-3"
				:style="{ backgroundImage: `url('${option.image}')`}"
				:title="option.label">
			</div>
			<div class="media-body">
				<div class="list-option-title">{{ option.label }}</div>
				<div></div>
			</div>
		</li>
	</ul>
</template>

<script>
import { duplicateVar } from '../lib/helper';

export default {
	name: 'OptionsList',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		options: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		onClick(key) {
			const selected = duplicateVar(this.value);
			const index = selected.indexOf(key);
			if (index === -1) {
				selected.push(key);
			} else {
				selected.splice(index, 1);
			}
			this.$emit('input', selected);
		},
	},
};
</script>
